import {
  ImageBackground,
  StyleSheet,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React from "react";
import { View, ScrollView, Box } from "native-base";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";
import Swiper from "react-native-web-swiper";

const maps = [
  require("../../assets/nutrient_maps/map1.png"),
  require("../../assets/nutrient_maps/map2.png"),
  require("../../assets/nutrient_maps/map3.png"),
  require("../../assets/nutrient_maps/map4.png"),
  require("../../assets/nutrient_maps/map5.png"),
  require("../../assets/nutrient_maps/map6.png"),
  require("../../assets/nutrient_maps/map7.png"),
  require("../../assets/nutrient_maps/map8.png"),
  require("../../assets/nutrient_maps/map9.png"),
  require("../../assets/nutrient_maps/map10.png"),
  require("../../assets/nutrient_maps/map11.png"),
];
const NutrientMaps = ({ navigation }: StackScreenProps<"NutrientMaps">) => {
  const { width, height } = useWindowDimensions();

  const renderItem = ({ item, index }: { item: any[]; index: number }) => {
    return (
      <Box w={"2/3"} h={400} alignSelf="center">
        <ImageBackground
          source={item}
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          resizeMode="contain"
          imageStyle={{ borderRadius: 5 }}
        ></ImageBackground>
      </Box>
    );
  };

  return (
    <ImageBackground
      source={require("../../assets/soil-research-bg.png")}
      resizeMode="cover"
      style={[styles.imageContainer, { height: height, width }]}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height: "100%" }}>
          <ScrollView px="6">
            <Header
              onPress={() => navigation.navigate("SoilResearch")}
              parentText="Soil Research"
              headingText="Nutient Maps"
            />

            <View h={400}>
              <Swiper
                controlsProps={{
                  prevPos: false,
                  nextPos: false,
                }}
              >
                {maps?.map((item, index) => renderItem({ item, index }))}
              </Swiper>
            </View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default NutrientMaps;

const styles = StyleSheet.create({
  imageContainer: {
    // flex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(36,2,7,0.8)",
  },
});
